import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { queryClient } from "./queryClient";

/**
 * Application-wide providers.
 *
 * Everything the tree needs regardless of route. Kept deliberately thin — a
 * provider that grows business logic becomes a place nobody thinks to look.
 */
export function Providers({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
